module.exports = __webpack_public_path__ + "media/images/home/concept_scene_5-c293d433a8e2e80925659611e85f14ca.png";